/**
 * Idempotency cleanup scheduler: rimuove periodicamente record scaduti.
 */

import { idempotencyService } from './idempotency-service';
import { debugError, debugLog } from '../../utils/debug';

const CLEANUP_INTERVAL_MS = 60 * 60 * 1000; // 1 ora

class IdempotencyCleanupScheduler {
  private _intervalId: ReturnType<typeof setInterval> | null = null;

  start(): void {
    if (this._intervalId !== null) return;
    void this._cleanup();
    this._intervalId = setInterval(() => void this._cleanup(), CLEANUP_INTERVAL_MS);
    debugLog('[IdempotencyCleanup] Scheduler started');
  }

  stop(): void {
    if (this._intervalId !== null) {
      clearInterval(this._intervalId);
      this._intervalId = null;
    }
  }

  private async _cleanup(): Promise<void> {
    try {
      await idempotencyService.cleanup();
    } catch (error) {
      debugError('[IdempotencyCleanup] Error:', error);
    }
  }
}

export const idempotencyCleanupScheduler = new IdempotencyCleanupScheduler();
